import { render, staticRenderFns } from "./waterfall_2.vue?vue&type=template&id=32e9ad90&scoped=true&"
import script from "./waterfall_2.vue?vue&type=script&lang=js&"
export * from "./waterfall_2.vue?vue&type=script&lang=js&"
import style0 from "./waterfall_2.vue?vue&type=style&index=0&id=32e9ad90&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e9ad90",
  null
  
)

export default component.exports